import api from "@/lib/api";

/** Native (Capacitor) background geofencing bridge. No-op in a normal browser. */
const cap = () => (typeof window !== "undefined" && window.Capacitor && window.Capacitor.isNativePlatform?.() ? window.Capacitor : null);
export const isNative = () => !!cap();
let watcherId = null; let plugin = null;

const getPlugin = () => { const c = cap(); if (!c) return null; if (!plugin) { try { plugin = c.Plugins?.BackgroundGeolocation || c.registerPlugin("BackgroundGeolocation"); } catch { plugin = null; } } return plugin; };

export async function startNativeWatch(onFix) {
  const p = getPlugin(); if (!p || watcherId) return false;
  try {
    watcherId = await p.addWatcher({
      backgroundMessage: "Verifying you are inside the office campus. Stops automatically at Off Duty.",
      backgroundTitle: "Duty Mode active", requestPermissions: true, stale: false, distanceFilter: 25,
    }, async (loc, err) => {
      if (err) { if (err.code === "NOT_AUTHORIZED") { try { await p.openSettings(); } catch { /* ignore */ } } onFix?.({ geo_error: err.message || err.code }); return; }
      if (!loc) return;
      const fix = { lat: loc.latitude, lng: loc.longitude, accuracy: Math.round(loc.accuracy || 0), speed: loc.speed, ts: new Date(loc.time || Date.now()).toISOString(), mock: !!loc.simulated, native: true };
      try { const { data } = await api.post("/hr/me/geo/ping", fix); onFix?.({ ...data, fix, at: Date.now() }); if (data.auto_off || data.tracking === false) await stopNativeWatch(); }
      catch { onFix?.({ inside: null, reason: "offline", fix, at: Date.now() }); }
    });
    return true;
  } catch { watcherId = null; return false; }
}

export async function stopNativeWatch() {
  const p = getPlugin(); if (!p || !watcherId) return;
  try { await p.removeWatcher({ id: watcherId }); } catch { /* ignore */ } finally { watcherId = null; }
}
